import { render, staticRenderFns } from "@/manager/sync/views/syncDetail/kpiModal/kpiModal.pug?vue&type=template&id=2742fc3f&scoped=true&lang=pug&external"
import script from "./kpiModal.view.vue?vue&type=script&lang=ts"
export * from "./kpiModal.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/sync/views/syncDetail/kpiModal/kpiModal.scss?vue&type=style&index=0&id=2742fc3f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742fc3f",
  null
  
)

export default component.exports